import { LOGOUT, TOKEN_EXPIRED, LOGIN_SUCCESS, LOGIN_FAILURE, LOGIN_REQUEST, SET_QR_SECERET_KEYS } from '../constants/action-types';
import { LOGIN_STATUS } from '../constants';
import { clearSession, setLoginStatus, setLogoutMessage } from '../helpers/session';
import { deleteIndexData } from '../helpers/indexedDBUtils';

const initialState = {
    isRequest: false,
    userInfo: null,
    error: null,
    qrSeceretKeys: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            state = { ...initialState, isRequest: true };
            break;
        case LOGIN_SUCCESS:
            state = { ...initialState, isRequest: false, userInfo: action.payload };
            break;
        case LOGIN_FAILURE:
            state = { ...initialState, error: action.error };
            break;
        case LOGOUT: {
            if (window.socketClient) {
                window.socketClient.destroy();
                window.socketClient = null;
            }
            clearSession();
            setLoginStatus(LOGIN_STATUS.loggedout);
            deleteIndexData('geoRegionList');
            action.payload && action.payload.inactive && setLogoutMessage("Automatically logged out");
            window.location = '/';
            break;
        }
        case TOKEN_EXPIRED:
            const timer = setTimeout(() => {
                if (timer) clearTimeout(timer);
                clearSession();
                window.location = '/';
            }, 2000);
            break;
        case SET_QR_SECERET_KEYS: {
            if (!action.payload) break;

            state = {
                ...state,
                qrSeceretKeys: action.payload
            };
            break;
        }
        default:
            break;
    }
    return state;
}